/* "Load more" : recupere la page suivante, ajoute les cartes a la grille
   existante et met a jour le compteur. Pas de saut de page, pas de
   defilement infini -- le visiteur garde la main (demande user du 16/09).
   La grille se re-rend au filtrage : on delegue le clic au document. */
(function () {
  var enCours = false;

  function bloc(bouton) {
    return bouton.closest('.lv-plus');
  }

  async function charger(bouton) {
    if (enCours) return;
    var url = bouton.dataset.suite;
    if (!url) return;
    enCours = true;
    var libelle = bouton.textContent;
    bouton.textContent = 'Loading…';
    bouton.disabled = true;
    try {
      var rep = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!rep.ok) throw new Error('HTTP ' + rep.status);
      var doc = new DOMParser().parseFromString(await rep.text(), 'text/html');
      var grille = document.querySelector('.product-grid');
      var suivantes = doc.querySelectorAll('.product-grid .product-grid__item');
      if (!grille || !suivantes.length) throw new Error('page suivante vide');
      suivantes.forEach(function (n) { grille.appendChild(document.importNode(n, true)); });

      var b = bloc(bouton);
      var vus = b && b.querySelector('.lv-plus__vus');
      /* les tuiles editoriales portent aussi `product-grid__item` : sans le
         `:not(.lv-usp)` le compteur annoncait 56 pour 48 fiches (mesure du 17/09) */
      if (vus) vus.textContent = String(grille.querySelectorAll('.product-grid__item:not(.lv-usp)').length);

      var suite = doc.querySelector('.lv-plus__bouton');
      if (suite && suite.dataset.suite) {
        bouton.dataset.suite = suite.dataset.suite;
        bouton.textContent = libelle;
        bouton.disabled = false;
      } else {
        bouton.remove();
      }
      /* l historique suit la page atteinte : un retour arriere ne renvoie pas
         le visiteur en haut de la collection */
      try { history.replaceState(history.state, '', url); } catch (e) {}
    } catch (e) {
      bouton.textContent = libelle;
      bouton.disabled = false;
    } finally {
      enCours = false;
    }
  }

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('.lv-plus__bouton');
    if (!b) return;
    ev.preventDefault();
    charger(b);
  });
})();
